<div class="mu-map">
  <ng-content></ng-content>
  <app-mu-atlas
    [mapType]="mapType"
    [ngClass]="class"
    [options]="mapOptions"
    [overlays]="markers"
    (onMapReady)="_eventSetMap($event)"
  ></app-mu-atlas>
</div>
